module.exports = __webpack_public_path__ + "img/cb-key.521fa001.svg";